<template>
	<div class="product-grid">
		<div v-if="$i18n.locale == 'en'">
			<h2 class="section-title" v-if="products2.length > 0">{{ $t('products.title3')}}</h2>
			<div class="product-list">
				<div v-for="(product, index) in products2" :key="index" class="product-card" @click="gotoDetail(product)">
					<div class="product-image">
						<img :src="product.image" :alt="product.name" />
					</div>
					<h3 class="product-name">{{ product.title }}</h3>
					<!-- <p class="product-price">{{ product.subtitle }}</p> -->
				</div>
			</div>
		</div>

		<div v-else>
			<h2 class="section-title">{{ $t('products.title3') }}</h2>
			<div class="product-list">
				<div v-for="(product, index) in products" :key="index" class="product-card" @click="gotoDetail(product)">
					<div class="product-image">
						<img :src="product.image" :alt="product.name" />
					</div>
					<h3 class="product-name">{{ product.title }}</h3>
					<!-- <p class="product-price">{{ product.subtitle }}</p> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { productApi, baseImgUrl } from '../netTool/api';
export default {
	name: 'ProductGrid',
	data() {
		return {
			products: [],    // 非海外产品
			products2: []    // 海外产品
		};
	},
	mounted() {
		this.loadHomeProducts();
	},
	// watch: {
	// 	'$i18n.locale': {
	// 		handler(newVal) {
	// 			// console.log(newVal,"newValnewValnewVal");
	// 			let list = this.products
	// 			this.products = this.products2;
	// 			this.products2 = list;
	// 		},
	// 		deep: true
	// 	},
	// },
	methods: {
		async loadHomeProducts() {
			try {
				const response = await productApi.getProductList();
				if (response.success) {
					this.products = [];
					this.products2 = [];
					
					response.products.forEach((product) => {
						const formattedProduct = {
							image: product.image_url ? baseImgUrl + product.image_url : '',
							title: product.name,
							subtitle: `${product.is_overseas == 1 ? '$' : '¥'}${product.price}`,
							id: product.id,
							is_overseas: product.is_overseas || 0,
							link: product.product_link,
						};
						console.log(product.is_overseas,"is_overseas")
						if (product.is_overseas == 1) {
							console.log(product.is_overseas,product.title)
							this.products2.push(formattedProduct);
						} else {
							console.log(product.title,product.is_overseas)
							this.products.push(formattedProduct);
						}
					});
					// console.log(this.products,"productsproducts",this.products2);
					// if(this.$i18n.locale == 'en') {
					// 	let list = this.products
					// 	this.products = this.products2;
					// 	this.products2 = list;
					// }
				}
			} catch (error) {
				console.error('加载产品失败:', error);
			}
		},
		gotoDetail(product) {
			// 海外产品跳转到亚马逊，国内产品跳转到天猫
			if(product.link) {
				window.open(product.link)
			}
			// this.$router.push(`/productDetail/${product.id}`);
		}
	}
};
</script>

<style scoped>
.product-grid {
	padding: 20px;
	max-width: 1200px;
	margin: 0 auto;
	margin-top: 35px;
	margin-bottom: 90px;
}

.section-title {
	font-size: 24px;
	color: #333;
	margin-bottom: 30px;
	text-align: left;

	padding-bottom: 15px;
	border-bottom: 2px solid #ebebeb;
}

.product-list {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 24px;
}

.product-card {
	overflow: hidden;
	transition: transform 0.2s ease;
}

.product-card:hover {
	transform: translateY(-5px);
}

.product-image {
	border-radius: 12px;
	background-color: #ebebeb;
	padding-top: 100%; /* 1:1 宽高比 */
	position: relative;
	overflow:hidden;
}

.product-image img {
	position: absolute;
	top: 0%;
	left: 0%;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.product-name {
	font-size: 16px;
	color: #333;
	margin: 15px;
	text-align: center;
	margin-bottom: 20px;
}

.product-price {
	font-size: 14px;
	color: var(--active-nav-color);
	margin: 0 15px 20px;
	text-align: center;
}

/* 移动端适配 */
@media (max-width: 768px) {
	.product-list {
		grid-template-columns: repeat(3, 1fr);
		gap: 16px;
	}

	.section-title {
		font-size: 20px;
		margin-bottom: 20px;
	}

	.product-card {
		margin-bottom: 0; /* 网格布局不需要底部margin */
	}
}

@media (max-width: 480px) {
	.product-list {
		grid-template-columns: 2fr;
	}

	.section-title {
		font-size: 18px;
	}
}
</style>
